import { userFacingError } from "../authorization";
import { branchRole } from "../branchRole";
import { type Schema, zql } from "../generatedDrizzleSchema";
import { actorColumns, type AttributionCtx } from "../rbac/roles";
import type { Transaction } from "@rocicorp/zero";

export async function assertNotSelfApproval(
  tx: Transaction<Schema>,
  actorCtx: AttributionCtx,
  sourceBranchId: string,
  workflowId: string
) {
  const workflow = await tx.run(zql.workflows.where("id", workflowId).one());
  if (!workflow) return;
  const space = await tx.run(zql.spaces.where("id", workflow.spaceId).one());
  if (!space?.blockSelfApproval) return;

  const { userId } = actorColumns(actorCtx);
  if (!userId) {
    throw userFacingError(
      "This space requires a different user to push branches live, and a service account cannot be that user"
    );
  }
  const branch = await tx.run(
    zql.workflowBranches
      .where("id", sourceBranchId)
      .related("contributors", (c) => c.where("userId", userId))
      .one()
  );
  const isOwner =
    branch?.userId === userId &&
    branchRole({ id: sourceBranchId, workflow }) === "other";
  if (!isOwner && !branch?.contributors.length) return;
  throw userFacingError(
    "This space requires a different user to push branches live"
  );
}
